import React, { useRef, useState, useEffect } from 'react'
import LogoutIcon from '@material-ui/icons/ExitToApp';
import classNames from 'classnames'
import { AppBar, Toolbar, Drawer, Divider, IconButton, Badge, Box, Typography, List, CssBaseline, Button, makeStyles, ListItemText, ListItem, ListItemIcon, Menu, Tooltip } from '@material-ui/core'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import NotificationsIcon from '@material-ui/icons/Notifications'
import { useDispatch, useSelector } from 'react-redux'
import MenuIcon from "@material-ui/icons/Menu"
import AddIcon from '@mui/icons-material/Add'
import { mainListItems } from './listItems'
import { customTheme } from '../styling'
import LogoAfr from '../images/logo-afr.svg'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
const drawerWidth = 260
import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import axios from '../axios'
import { getRoleUserIdFromToken } from '../utils';
import { enqueueSnackbar } from 'notistack';
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    backgroundColor: 'white',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    color: 'rgba(0, 0, 0, 0.87)',
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    marginTop: '0.5rem'
  },
  drawerPaper: {
    height: '100vh',
    backgroundColor: 'white',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9)
    },
  },
  button1: {
    marginRight: '1rem'
  },
  button2: {
    backgroundColor: customTheme.colors.ui.green,
    color: 'white',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: customTheme.colors.ui.green,
      opacity: '0.9'
    },
  }
}))

const AppBarMain = ({ children }) => {
  const classes = useStyles()
  const { drawerOpen, notificationsChanged } = useSelector((state) => state.ui)
  const history = useHistory()
  const [anchorMenuEl, setAnchorMenuEl] = React.useState(null)
  const openMenu = Boolean(anchorMenuEl)
  const [userDetails, setUserDetails] = useState(null)
  const dispatch = useDispatch()
  const token = localStorage.getItem('afr-portale-authorization-token')
  const decodedToken = token && jwtDecode(token)
  const nameCompany  = decodedToken?.data?.nameCompany
  const [notifications, setNotifications] = useState(null)
  const roleUserId = getRoleUserIdFromToken()

  const handleCloseMenu = () => {
    setAnchorMenuEl(null);
  }


  const handleDrawerOpen = () => {
    dispatch({
      type: 'DRAWER_OPEN',
    })


  }
  const handleDrawerClose = () => {
    dispatch({
      type: 'DRAWER_CLOSE',
    })

  }


  useEffect(() => {
    let url 
    if(roleUserId === 2){
      url = '/get-list-orders?orderBy=notificationAgentOn&direction=DESC&submittedBy=3&first=30&archived=0'
   }else{
       url = '/get-list-orders?orderBy=notificationOn&direction=DESC&first=30&archived=0'
   }
    axios.get(url).then((res) => {
      setNotifications(res.data.count)
    }).catch((error) => {
      
    })
  }, [notificationsChanged])

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={classNames(classes.appBar)}
      >
        <Toolbar className={classes.toolbar} style={{ justifyContent: 'right' }}>


          {!drawerOpen && <Button
            style={{ position: 'relative', right: '2rem' }}
            color="inherit"
            aria-label="Open drawer"
            onClick={handleDrawerOpen}
            className={classNames(
              classes.menuButton,

            )}
          >
            <MenuIcon style={{ height: '3rem', }} />
          </Button>
          }
          {drawerOpen && <Button
              style={{ position: 'relative', right: '2rem' }}
              color="inherit"
              aria-label="Open drawer"
              onClick={handleDrawerClose}
              className={classNames(
                classes.menuButton,

              )}
            >
              <ChevronLeftIcon style={{ color: customTheme.colors.ui.greyVeryDark, height: '3rem' }} />
            </Button>
          }



          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            <img src={LogoAfr} style={{ height: '3rem' }} />
          </Typography>
          
          {notifications !== null &&<IconButton color="inherit" onClick={() => history.push('/notifications')}>
              <Badge badgeContent={notifications} overlap="rectangular" style={{color:customTheme.colors.ui.yellow}}>
                <NotificationsIcon />
              </Badge>
            </IconButton>
          }




          <Menu
            id="basic-menu"
            anchorEl={anchorMenuEl}
            open={openMenu}
            onClose={handleCloseMenu}
            style={{ marginTop: '2rem', }}

          >
            <Box style={{ padding: '1rem', width: '45vw' }}>
              <Typography style={{ fontWeight: 'bold' }}>Funzionalità</Typography>
              <Box style={{ display: 'grid', gridTemplateColumns: '1.3fr 1.3fr 1fr', marginTop: '1rem', lineHeight: 3, fontSize: '1rem' }}>
                <Box>Chat</Box>
                <Box>1300 caratteri</Box>
                <Box style={{ textDecoration: 'underline', color: customTheme.colors.ui.green, cursor: 'pointer' }} onClick={handleCloseMenu}>Richiedi upgrade</Box>


                <Box>Chat Mini</Box>
                <Box>Illimitati</Box>
                <Box style={{ textDecoration: 'underline', color: customTheme.colors.ui.green, cursor: 'pointer' }} onClick={handleCloseMenu}>Richiedi upgrade</Box>


                <Box>Translator (documenti)</Box>
                <Box>Illimitati</Box>
                <Box style={{ textDecoration: 'underline', color: customTheme.colors.ui.green, cursor: 'pointer' }} onClick={handleCloseMenu}>Richiedi upgrade</Box>


                <Box style={{ color: customTheme.colors.ui.grey }}>Translator (testo)</Box>
                <Box style={{ color: customTheme.colors.ui.grey }}>Bloccato</Box>
                <Box style={{ textDecoration: 'underline', color: customTheme.colors.ui.red, cursor: 'pointer' }} onClick={handleCloseMenu}>Richiedi accesso</Box>


                <Box style={{ color: customTheme.colors.ui.grey }}>Text to speech</Box>
                <Box style={{ color: customTheme.colors.ui.grey }}>Bloccato</Box>
                <Box style={{ textDecoration: 'underline', color: customTheme.colors.ui.red, cursor: 'pointer' }} onClick={handleCloseMenu}>Richiedi accesso</Box>


                <Box style={{ color: customTheme.colors.ui.grey }}>Speech to Speech</Box>
                <Box style={{ color: customTheme.colors.ui.grey }}>Bloccato</Box>
                <Box style={{ textDecoration: 'underline', color: customTheme.colors.ui.red, cursor: 'pointer' }} onClick={handleCloseMenu}>Richiedi accesso</Box>


                <Box>AI images</Box>
                <Box>1300 immagini</Box>
                <Box style={{ textDecoration: 'underline', color: customTheme.colors.ui.green, cursor: 'pointer' }} onClick={handleCloseMenu}>Richiedi upgrade</Box>

                <Box style={{ color: customTheme.colors.ui.grey }}>Video maker</Box>
                <Box style={{ color: customTheme.colors.ui.grey }}>Bloccato</Box>
                <Box style={{ textDecoration: 'underline', color: customTheme.colors.ui.red, cursor: 'pointer' }} onClick={handleCloseMenu}>Richiedi accesso</Box>

              </Box>
            </Box>


          </Menu>





        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(classes.drawerPaper, !drawerOpen && classes.drawerPaperClose),
        }}

        open={drawerOpen}
      >
        {/* <div className={classes.toolbarIcon}>
          {drawerOpen &&
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
              style={{ textAlign: 'center' }}
            >
              <img src={LogoAfr} style={{ height: '6vh' }} />
            </Typography>
          }

          <Button onClick={handleDrawerClose}>
            <ChevronLeftIcon style={{ color: customTheme.colors.ui.greyVeryDark, }} />
          </Button>

        </div> */}

        <List style={{marginTop:'4rem'}} >{mainListItems()}</List>

        <Box style={{ marginBottom: '0.5rem' }}>
          <List>
            <ListItem >
              <ListItemIcon>
                <AccountCircleIcon style={{ color: 'black', fontSize: '2rem' }} />
              </ListItemIcon>
              <ListItemText style={{ color: 'black' }} primary={<Typography style={{ whiteSpace:'initial' }}>{nameCompany}</Typography>} />
            </ListItem>
          </List>

          <List style={{  }}>
            <ListItem button onClick={() => {
              localStorage.removeItem('afr-portale-authorization-token')
              history.push('/login')
            }}>
              <ListItemIcon>
                <LogoutIcon style={{ color: 'black', fontSize: '2rem' }} />
              </ListItemIcon>
              <ListItemText style={{ color: 'black' }} primary="Disconnetti" />
            </ListItem>
          </List>
        </Box>


      </Drawer>
      {children}
    </div>
  )
}

export default AppBarMain